import type { ReturnedReference } from '../components/Create-Portfolio/types';

export function getPortfolioReferences(portfolio: unknown): ReturnedReference[] {
  const refs = (portfolio as { references?: ReturnedReference[] } | null)?.references;
  return Array.isArray(refs) ? refs : [];
}
